import React from 'react';
import '../styles/Button.css';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  href?: string;
  target?: string;
}

const Button: React.FC<ButtonProps> = ({ children, onClick, type = 'button', disabled = false, href, target }) => {
  if (href) {
    return (
      <a
        className="button"
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  return (
    <button className="button" onClick={onClick} type={type} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;
